import type { QueryClient } from '@tanstack/react-query';

/**
 * Drops every cached query that belongs to a workspace, keeping auth queries.
 *
 * Query keys don't carry the workspace id — it travels on the `x-workspace-id`
 * header — so after a workspace switch the previous workspace's rows keep being
 * served until each query goes stale (and, where the cache is persisted, across
 * reloads too). Auth queries are deliberately spared: they describe the signed-in
 * user and the workspaces they can reach, so evicting them mid-switch bounces the
 * app back to the workspace selector.
 */
export function removeWorkspaceScopedQueries(queryClient: QueryClient): void {
  queryClient.removeQueries({
    predicate: (query) => !JSON.stringify(query.queryKey).includes('"auth"'),
  });
}
